export const STANDARD = "STANDARD";
export const BUSINESS_ENTITY = "BUSINESS_ENTITY";